import { useEffect, useRef, useState, useCallback } from "react";

const WS_BASE = process.env.REACT_APP_BACKEND_URL
  .replace("https://", "wss://")
  .replace("http://", "ws://");

export function usePortfolioWS(token) {
  const wsRef = useRef(null);
  const [connected, setConnected] = useState(false);
  const [lastMessage, setLastMessage] = useState(null);
  const reconnectTimer = useRef(null);

  const connect = useCallback(() => {
    if (!token) return;
    try {
      const ws = new WebSocket(`${WS_BASE}/api/ws/portfolio?token=${token}`);
      wsRef.current = ws;

      ws.onopen = () => {
        setConnected(true);
        // Ping every 25s to keep alive
        reconnectTimer.current = setInterval(() => {
          if (ws.readyState === WebSocket.OPEN) ws.send("ping");
        }, 25000);
      };

      ws.onmessage = (e) => {
        try {
          const data = JSON.parse(e.data);
          if (data.type !== "pong") setLastMessage(data);
        } catch {}
      };

      ws.onclose = () => {
        setConnected(false);
        clearInterval(reconnectTimer.current);
        // Reconnect after 5s
        setTimeout(() => connect(), 5000);
      };

      ws.onerror = () => ws.close();
    } catch {}
  }, [token]);

  useEffect(() => {
    connect();
    return () => {
      clearInterval(reconnectTimer.current);
      if (wsRef.current) wsRef.current.close();
    };
  }, [connect]);

  return { connected, lastMessage };
}
